import Game from 'Game';
import { IAPReward } from 'Utility/RewardHelper';
import { ProductId } from 'Utility/Product';
import { report } from 'report';
import { GameActions } from 'State/Game/GameActions';
import { getIAPRewards, isIAPDeprecated } from 'Utility/Helpers/IAP/IAPRewards';
import { IPurchaseConsumptionData } from 'State/Player/IAP/IAPStateHelper';
import { captureException } from 'Sentry';

export async function handleIAP() {
    const fetchCatalogSucceed = await Game.sdk.fetchCatalog();
    if (!fetchCatalogSucceed) return;

    validateProductIds();

    const unconsumedPurchases = await Game.sdk.resolveUnconsumedPurchases();

    // TODO: what if `ProductId` doesn't match?
    const IAPRewardData: IAPReward[] = getIAPRewards();
    const iapRewardById: { [key in ProductId]?: IAPReward } = Object.fromEntries(IAPRewardData.map(r => [r.id, r]));

    const filteredRewards: IPurchaseConsumptionData[] = unconsumedPurchases
        .map((productPurchased: FBInstant.Purchase) => {
            return { productReward: iapRewardById[productPurchased.productID as ProductId], productPurchased };
        })
        .filter(purchaseData => Boolean(purchaseData.productReward));

    const failedIds = unconsumedPurchases.filter((id: ProductId) => !iapRewardById[id]);

    if (failedIds.length > 0) {
        report('Failed to find reward data for unconsumed purchases', {
            tags: {
                failedIds: `"${failedIds.join('","')}"`,
            },
            fingerprint: 'MissingRewardData4UnconsumedPurchase',
        });
    }

    GameActions.enableIAP(filteredRewards);
}

/**
 * Check if all the products (not locked) that we have in the game are present in the platform's
 * settings (in case of FB Instant Games it's in "FB Admin Panel"/"Meta for Developers").
 * If any product is absent then we console.error it and send to Sentry.
 */
function validateProductIds(): void {
    const productIdsMap: Map<ProductId, true> = new Map();
    Game.sdk.getCatalog().products.forEach(product => productIdsMap.set(product.productId as ProductId, true));
    const IAPRewardData: IAPReward[] = getIAPRewards();
    const absent = IAPRewardData
        .filter(product => {
            if (productIdsMap.has(product.id)) return false;
            // If the product is deprecated then it's ok if the platform doesn't have this product.
            return !isIAPDeprecated(product.id)
        })
        .map(p => p.id);
    const len = absent.length;
    if (len < 1) return;

    const list = absent.join(',');
    const message = `The following productIds (${len}) are absent in the platform's list of products: ${list}`;
    captureException({
        message,
        tags: {
            absentProductIds: list,
        },
        fingerprint: 'AbsentProductIds',
    });
    console.error(message);
}